<template>
<!--    <div class="profile-popup-overlay" v-if="isOpen">
        <div class="profile-popup-content">
            <button class="profile-popup-close" @click="closePopup"><i class="fa fa-times"></i></button>
        </div>
    </div>-->
  <div class="w-100 top-cart-summary" v-if="hasProduct">
    <div class="container-fluid top-cart-summary-header" style="background: #e2e2e2; border-bottom: 1px solid rgb(170, 170, 170)">
      <div class="container">
        <div class="py-3 px-2">
          <div @click="toggleCollapse" class="d-flex justify-content-between align-items-center" style="cursor: pointer;">
            <div>
              <span>{{ $t("Cart Summary") }}</span>
            </div>
            <div>
              <span v-if="isCollapsed" class="fa fa-chevron-up"></span>
              <span v-else class="fa fa-chevron-down"></span>
            </div>
            <div>
              <h4 v-if="live_cart.totals">{{ formatPrice(live_cart.totals.total) }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid top-cart-summary-body" :class="{ 'custom-padding': isCollapsed }" style="background: #e3e3e3;">
      <div class="container">
        <b-collapse id="collapse-body" :visible="isCollapsed">
          <CartRightSideDesktop :hasProduct="hasProduct" :updateCartLoading="updateCartLoading" :additionalServices="additionalServices" :installationServiceStatus="installationServiceStatus" :grand-total="GrandTotal" :shippingCharges="shippingCharges" :cartDetails="cartDetails"></CartRightSideDesktop>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CartRightSideDesktop from "./CartRightSideDesktop.vue";


export default {
    name: "CartRightSidebarPopupMobile",
    props: ["updateCartLoading", "hasProduct", 'calculatePrice', 'additionalServices', 'installationServiceStatus', 'shippingCharges', 'GrandTotal', 'cartDetails'],
    computed: {
        ...mapGetters('cart_right_sidebar', ['live_cart']),
    },
    components : {
        CartRightSideDesktop
    },
    methods: {
        ...mapActions('cart_popup_mobile', ['cpmSetIsOpen']),
        toggleCollapse() {
          this.isCollapsed = !this.isCollapsed;
        }
    },
    data() {
      return {
        isCollapsed: false
      };
    }

}
</script>

<style scoped>
.profile-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.profile-popup-content {
    background-color: #fff;
    width: 80%;
    max-width: 768px;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    max-height: 100vh;
    overflow-y: auto;
}

.profile-popup-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
}
.top-cart-summary {
  display: none;
}
@media screen and (max-width: 991px) {
  .top-cart-summary {
      display: block;
  }

  .custom-padding {
    padding-top: 20px;
    padding-bottom: 20px;
  }

}
</style>